import { IEntity } from './entity';

export type IEmailConfig = IEntity & {
  id: string;
  subject: string;
  fromAddress: string;
  to: [{ address: string }];
  cc: [{ address: string }];
  bcc: [{ address: string }];
};
